export class EmailOptions {
    fromAddress: string;
    toAddress: string[];
    ccAddress: string[];
    subject: string;
    body: string;
}
